import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import { TramoTipo } from '../models/tramo-tipo.model';
import { TramosTiposFilter } from '../models/tramos-tipos-filter';
import { TramosTiposFilterService } from './tramos-tipos-filter.service';

const defaultSortParam = 'id';
const defaultSortDirection = 'desc';

@Injectable()
export class TramosTiposService {
  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {}
  getAllTramosTipos(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetAllTramoTipo'], null);
    }
  }
  setTramoTipo(tv: TramoTipo): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.post(config.urls['apiUrl'] + api.endpoints['urlSetTramoTipo'], tv);
    }
  }

  removeTramoTipo(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteTramoTipo'].replace('{secure_id}', secure_id), null);
    }
  }

  getTramoTipo(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetTramoTipo'].replace('{secure_id}', secure_id), null);
    }
  }

  generateExcel(filter: TramosTiposFilter, sortDir: string, sortField: string): Observable<any> {
    const start = 0;
    const pageSize = 1000;

    sortField = sortField === undefined ? defaultSortParam : sortField;
    sortDir = sortDir === '' ? defaultSortDirection : sortDir;
    const params = new TramosTiposFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

    if (this.authGuard.canActivate()) {
      return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlTramosTiposExcel'],  params );
    }
  }
}
